import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class IFrameSchemaPlugin extends SchemaPlugin {
  nodes = {
    iframe: {
      group: 'inline',
      inline: true,
      atom: true,
      attrs: {
        src: { default: undefined },
      },
      parseDOM: [{
        tag: 'iframe',
        preserveWhitespace: true,
        getAttrs: function (dom: HTMLElement) {
          return {
            ...getSchemaAttrs(dom, ['src'])
          };
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'iframe',
      editorTagName: 'mc-lwe-iframe',
      isTagNameBox: true
    }
  } satisfies Record<string, NodeSpec>;
}
